export default "__VITE_ASSET__Npf$bWe6__"